export default () => {
  const els = {
    openButton: document.querySelectorAll('[data-video-modal-open]'),
    closeButton: document.querySelectorAll('[data-video-modal-close]'),
    video: document.querySelectorAll('[data-video-modal-video]'),
    modals: document.querySelectorAll('[data-video-modal]'),
    modal: null,
  };

  const closeModal = () => {
    const iframe = els.modal.querySelector('iframe');
    const video = els.modal.querySelector('video');
    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }
    if (video) {
      video.pause();
    }
    els.modal.classList.remove('active');
    document.body.overflow = '';
    setTimeout(() => {
      els.modal.style.display = 'none';
    }, 500);
  };

  const openModal = () => {
    els.modal.style.display = 'flex';
    document.body.overflow = 'hidden';
    setTimeout(() => {
      els.modal.classList.add('active');
    }, 500);
  };

  if (els.openButton) {
    els.openButton.forEach((el) => {
      el.addEventListener('click', (e) => {
        els.modal = document.getElementById(
          e.currentTarget.dataset.videoModalOpen
        );
        e.preventDefault();
        openModal();
      });
    });

    els.closeButton.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    els.video.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    els.modals.forEach((el) => {
      el.addEventListener('click', (e) => {
        closeModal();
      });
    });
  }
};
